import React, { type ReactElement, type ReactNode } from "react";

import classNames from "classnames";

import { ReactComponent as Icon_CheckmarkCircleFilled16 } from "../../assets/icons/CheckmarkCircleFilled16.svg";
import { ReactComponent as Icon_ExclamationFilled16 } from "../../assets/icons/ExclamationFilled16.svg";
import { ReactComponent as Icon_InfoFilled16 } from "../../assets/icons/InfoFilled16.svg";

// eslint-disable-next-line
import style from "./InfoBar.module.css";

export type InfoBarProps = {
  title?: ReactNode;
  text?: ReactNode;
  icon?: ReactElement;
  cta?: ReactNode;

  variant?: "information" | "attention" | "warning" | "critical" | "success";
  className?: string;
};

export const InfoBar: React.FC<InfoBarProps> = ({ title, text, icon, cta, variant, className }) => {
  return (
    <div className={classNames(style.infoBar, style[variant ?? "information"], className)}>
      <div className={style.content}>
        {icon && React.cloneElement(icon, { className: style.icon })}
        {!icon && variant === "success" && <Icon_CheckmarkCircleFilled16 className={style.icon} />}
        {!icon && (variant === "critical" || variant === "warning") && (
          <Icon_ExclamationFilled16 className={style.icon} />
        )}
        {!icon && (variant === "information" || variant === "attention") && (
          <Icon_InfoFilled16 className={style.icon} />
        )}
        {!icon && !variant && <Icon_InfoFilled16 className={style.icon} />}
        <div className={style.textContainer}>
          {title && <div className={style.title}>{title}</div>}
          {text && <div className={style.mainText}>{text}</div>}
        </div>
      </div>
      {cta && <div className={style.cta}>{cta}</div>}
    </div>
  );
};
